import CryptoJS from 'crypto-js';
const password = btoa('eagent');
const backendPassword = CryptoJS.SHA256("eagent"); // Laravel использует SHA256
export default {
    encrypt(plaintext) {
        return  CryptoJS.AES.encrypt(plaintext, password).toString();
    },
    decrypt(plaintext) {
        const bytes = CryptoJS.AES.decrypt(plaintext, password);
        return  bytes.toString(CryptoJS.enc.Utf8);
    },
    encryptBackend(plaintext) {
        const iv = CryptoJS.lib.WordArray.random(16);
        const encrypted = CryptoJS.AES.encrypt(plaintext, backendPassword, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return CryptoJS.enc.Base64.stringify(iv.concat(encrypted.ciphertext));
    },
    decryptBackend(ciphertext) {
        const rawData = CryptoJS.enc.Base64.parse(ciphertext);
        const iv = CryptoJS.lib.WordArray.create(rawData.words.slice(0, 4), 16);
        const encrypted = CryptoJS.lib.WordArray.create(rawData.words.slice(4), rawData.sigBytes - 16);
        const decrypted = CryptoJS.AES.decrypt({ ciphertext: encrypted }, backendPassword, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }
}